import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { getAreaByTerminalType } from '@/services/service-permission.service'
import { AuthStatusList } from '@/views/dashboard/_type/client-item'

export interface FileList {
  /** 操作系统 */
  os: string
  /** 文件大小 */
  size: string
}
export interface PatchInfo {
  /** 补丁编号 */
  kb_number: string
  /** 补丁文件类型 */
  file_list: FileList[]
  /** 发布日期 */
  patch_pub_date: string
  /** 安全公告 */
  safe_notice: string
  /** 漏斗影响 */
  affects: string
  /** 漏洞说明 */
  production: string
  /** 官方介绍 */
  official_page_url: string
}
export interface PatchQueryParams {
  /** 补丁编号 */
  kb_number: string
}

export interface LeakViewQueryParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序顺序 */
  asc?: boolean
  /** 排序字段 */
  sort?: string
  device_id?: string
  warn_level: number
  // 补丁编号
  kb_number: string
}

export interface LeakList {
  /** 补丁编号 */
  kb_number: string
  /** 补丁描述 */
  kb_desc: string
  /** 补丁发布日期 */
  kb_pub_date: string
  /** 漏洞类型 */
  leak_type: string
  /** 漏洞级别 */
  warn_level: number
  /** 漏洞级别中文名 */
  warn_level_str: string
  /** 终端数量 */
  terminal_count: number
  /** 修复状态 "未修复" 0"修复中" 1*/
  fix_status: number
  /** 补丁包数量 */
  patch_count: number
  /** 补丁信息 */
  patch_info?: PatchInfo
}

export interface LeakTerminalQueryParams {
  /** 分组id */
  group_id: number
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序 */
  asc?: boolean
  /** 排序字段 */
  sort?: string
  keyword: string,
  range: number,
  system_type: number,
  permission_names?: string[]
}

export interface LeakTerminalList {
  /** 终端设备id */
  device_id: string
  /** 计算机名 */
  computer_name?: string
  /** 分组id */
  group_id: number
  /** 分组名 */
  group_name: string
  /** 外网IP */
  system_ip: string
  /** 内网IP */
  client_ip: string
  /** 操作系统 */
  os: string
  /** 漏洞数量 */
  leak_count: number
  /** 高危漏洞数量 */
  high_risk_count: number,
  /** 扫描时间 */
  scan_time: number,
  /** 登录状态 */
  login_status?: number
  system_type: number
  /** 授权状态集合 */
  auth_status?: AuthStatusList[]
  /** 前端字段 */
  area_type?: number
  // 扫描状态 0-未扫描，1-扫描中，2-扫描完成，3-扫描失败，4-扫描超时
  scan_status: 0|1|2|3|4
  /** 登记用户名 */
  user_mark?: string
}

@Injectable()
export class VulnerabilityFixService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  getPatchInfo (data: PatchQueryParams) {
    return this.http.post<{
      patch_info: PatchInfo
    }>('/leak/patch-get', data)
  }

  getTeamLeakStat () {
    return this.http.post<{
      /** 漏洞数 */
      leak_count: number
      /** 影响的终端数 */
      terminal_count: number
      /** 高危漏洞数量 */
      high_risk_count: number
      /** 可选漏洞数量 */
      optional_count: number
      /** 包含高危漏洞终端数量 */
      high_risk_terminal_count: number
    }>('/leak/team-leak/stat', {})
  }

  @ParamsClean()
  getLeakList (data: LeakViewQueryParams) {
    return this.http.post<{
      list?: LeakList[]
      total?: number
    }>('/leak/leak-view/stat-leak', data)
  }

  @ParamsClean()
  getLeakTerminals (data: LeakTerminalQueryParams) {
    return this.http.post<{
      list: LeakTerminalList[]
      total: number
    }>('/leak/terminal-view/stat-leaks', data).then(res => {
      res.list.forEach(v => v.area_type = getAreaByTerminalType(v.system_type))
      return res
    })
  }
}
